import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ArticleItemComponent} from './article-item/article-item.component';
import {ArticleListComponent} from './article-list/article-list.component';
import {CalendarComponent} from './calendar/calendar.component';
import {ContentsComponent} from './contents/contents.component';

const routes: Routes = [
    {
        path: 'tartalmak',
        children: [
            {path: '', component: ContentsComponent},
            {
                path: 'hirek',
                children: [
                    {path: '', component: ArticleListComponent},
                    {path: ':id', component: ArticleItemComponent},
                ]
            },
            {path: 'naptar', component: CalendarComponent},
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ContentsRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/contents-routing.module.ts